import { createTheme } from '@mantine/core';

// Mobile-only тёмная тема. Контент капается на 430px (iPhone Pro Max width)
// и центрируется — на desktop'е тот же mobile-layout, как заказал пользователь.
export const theme = createTheme({
    primaryColor: 'indigo',
    defaultRadius: 'md',
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontFamilyMonospace:
        'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
    headings: {
        fontWeight: '600',
    },
});
